import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import dayjs from 'dayjs'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify/lib'
import VueTour from 'vue-tour'
import Notifications from 'vue-notification'

require('vue-tour/dist/vue-tour.css')

Vue.config.productionTip = false

Vue.use(VueTour)
Vue.use(Notifications)

Vue.use(Vuetify, {
	theme: {
		primary: '#1976D2',
		secondary: '#424242',
		accent: '#82B1FF',
		error: '#FF5252',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#FFC107',
		onprimary: '#FFFFFF',
	},
})

Vue.use(VueClipboard)

new Vue({
	data: {
		affiliate: {},
		advertiserList: {},
		period: {
			startDate: dayjs().startOf('day'),
			endDate: dayjs().endOf('day'),
		},
	},
	router,
	render: (h) => h(App),
}).$mount('#app')
